export default __webpack_public_path__ + "static/media/image4-6.5f6d92a6.png";